import React, { useEffect, useRef, useState } from "react";
import Layouts from "../../Layouts";
import { Input, Modal, Spin, message } from "antd";
import PatientList from "./PatientList";
import { useForm } from "antd/es/form/Form";
import "dayjs/plugin/utc";
import FilterPatient from "./FilterPatient";
import PatientService from "../../../Services/PatientService";
import NewPatientRegister from "./NewPatientRegister";
import { FaFilter } from "react-icons/fa6";
import { FaSearch } from "react-icons/fa";
import PatientQueue from "../VCPage/PatientQueue";
import patientqueue from "../../../Assets/Images/Svg/queue2.svg";
import { IoIosCloseCircle, IoMdClose } from "react-icons/io";
import Draggable from "react-draggable";
import { MdKeyboardDoubleArrowUp } from "react-icons/md";
import { IoPersonAdd } from "react-icons/io5";
import { useDispatch, useSelector } from "react-redux";
import {
  clearSelectedEditPatient,
  handleClearPatientRegistrationPayload,
} from "../../../Redux/actions/patientActions";
import RPMPatientRegistration from "./AddNewPatient";

function Patients() {
  const [loading, setLoading] = useState(false);
  const storedLoginResult = localStorage.getItem("login_result");
  const loginResultObject = storedLoginResult
    ? JSON.parse(storedLoginResult)
    : null;
  const [saveModal, setSaveModal] = useState(false);
  const [form, setForm] = useForm();
  const [patientData, setPatientData] = useState([]);
  const [filterModal, setFilterModal] = useState(false);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [isVerticalOpen, setIsVerticalOpen] = useState(true);
  const [searchAttempted, setSearchAttempted] = useState(false);
  const videoRef = useRef(null);
  const [rpmFilterMode, setRpmFilterMode] = useState(false);
  const dispatch = useDispatch();
  const { patientsList } = useSelector((state) => state.patients);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const stopCamera = () => {
    if (videoRef.current && videoRef.current.srcObject) {
      const stream = videoRef.current.srcObject;
      const tracks = stream.getTracks();
      tracks.forEach((track) => track.stop());
      videoRef.current.srcObject = null;
    }
  };

  const getPatientList = async (filterPayload) => {
    setLoading(true);
    setSearchAttempted(true);

    const payload = {
      ...filterPayload,
      account_Id: loginResultObject.user.account_Id,
    };

    try {
      const res = await PatientService.PatientListFilter(payload);
      setPatientData(res?.data || []);
    } catch (error) {
      message.error("Error occurred... try again");
      setPatientData([]);
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const handleOk = () => {
    form.resetFields();
    dispatch(handleClearPatientRegistrationPayload(null));
    dispatch(clearSelectedEditPatient(null));
    setSaveModal(false);
    stopCamera();
  };

  const handleCancel = () => {
    form.resetFields();
    dispatch(handleClearPatientRegistrationPayload(null));
    dispatch(clearSelectedEditPatient(null));
    setSaveModal(false);
    stopCamera();
  };

  const handleKeyPress = (e) => {
    const allowedKeys = [
      "0",
      "1",
      "2",
      "3",
      "4",
      "5",
      "6",
      "7",
      "8",
      "9",
      "Backspace",
      "Delete",
      "ArrowLeft",
      "ArrowRight",
      "Tab",
    ];
    if (!allowedKeys.includes(e.key)) {
      e.preventDefault();
    }
  };

  const handleInputChange = async (e) => {
    const value = e.target.value;
    setPatientData([]);

    if (value.length <= 3) {
      setLoading(false);
      setSearchAttempted(false);
      return;
    }

    setSearchAttempted(true);
    setLoading(true);

    try {
      const payload = {
        firstName: value,
        account_Id: loginResultObject.user.account_Id,
      };
      const res = await PatientService.PatientListFilter(payload);
      setPatientData(res?.data || []);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const showModal3 = () => {
    dispatch(handleClearPatientRegistrationPayload(null));
    dispatch(clearSelectedEditPatient(null));
    setSaveModal(true);
  };

  const showModal2 = () => {
    setFilterModal(true);
  };

  const handleFilterOk = () => {
    setFilterModal(false);
  };

  const handleFilterCancel = () => {
    setFilterModal(false);
  };

  const onClose = () => {
    setIsDrawerOpen(false);
  };

  const showDrawer = () => {
    setIsDrawerOpen(true);
  };

  const handleClick = () => {
    setIsVerticalOpen(true);
  };
  const closeCircle = () => {
    setIsVerticalOpen(false);
  };

  const handleShowRpmPatients = () => {
    setRpmFilterMode(true);
    const payload = {
      rpmApplicable: "Y",
      account_Id: loginResultObject.user.account_Id,
    };
    getPatientList(payload);
  };

  const handleClearRpmFilter = () => {
    setRpmFilterMode(false);
    setPatientData([]);
    setLoading(false);
  };

  return (
    <Layouts>
      <div className="flex flex-col">
        <div className="font-bold font-sans text-lg">Patients</div>
        <div className="flex">
          <div className="flex justify-center md:w-[80%] items-center md:p-4 p-2">
            <Input
              className="md:w-[40%] w-full mr-2"
              placeholder="Search Patient"
              size="large"
              onChange={handleInputChange}
              suffix={
                <span className="bg-brand-primaryColor p-1 text-white rounded-md">
                  <FaSearch className="" />
                </span>
              }
            />
            {rpmFilterMode ? (
              ""
            ) : (
              <button
                className="text-white font-semibold font-sans gap-1 bg-brand-primaryColor p-2 rounded-md flex items-center "
                onClick={showModal2}
              >
                <FaFilter className="mr-1" />
                Filter
              </button>
            )}
            {loginResultObject.user.rpmApplicable === "Y" && (
              <div className="flex items-center ml-3 gap-2">
                <button
                  className="w-20 h-9 px-2 font-sans font-semibold rounded-md bg-brand-primaryColor text-white disabled:opacity-50 disabled:cursor-not-allowed"
                  onClick={handleShowRpmPatients}
                  disabled={rpmFilterMode}
                >
                  RPM
                </button>
                {rpmFilterMode && (
                  <p onClick={handleClearRpmFilter} className="rounded-md cursor-pointer w-5 h-5 border">
                    <IoMdClose className="text-lg text-red-800" />
                  </p>
                )}
              </div>
            )}
          </div>
          <div className="flex justify-end items-center w-[20%]">
            <button
              className="text-white font-semibold p-2 bg-brand-primaryColor rounded-md"
              onClick={showModal3}
            >
              <IoPersonAdd />
            </button>
          </div>
        </div>

        {loading ? (
          <div className="flex justify-center items-center py-4">
            <Spin tip="Loading patients..." />
          </div>
        ) : Array.isArray(patientData) && patientData.length > 0 ? (
          <PatientList
            handleKeyPress={handleKeyPress}
            patientData={patientData}
            getPatientList={getPatientList}
            setPatientData={setPatientData}
          />
        ) : searchAttempted ? (
          <p className="text-center text-gray-500 mt-4">
            No patients available
          </p>
        ) : (
          <p className="text-center text-gray-500 mt-4">
            Search to view Patients
          </p>
        )}

        {filterModal && (
          <Modal
            title="Filter Patient"
            open={filterModal}
            onOk={handleFilterOk}
            onCancel={handleFilterCancel}
            footer={[]}
            className="responsive-modal"
          >
            <FilterPatient
              setPatientData={setPatientData}
              handleFilterCancel={handleFilterCancel}
              setLoading={setLoading}
              setSearchAttempted={setLoading}
            />
          </Modal>
        )}
        {saveModal && (
          <Modal
            title={<span className="text-base font-sans font-bold">New Patient Registration</span>}
            open={saveModal}
            onOk={handleOk}
            onCancel={handleCancel}
            footer={[]}
            width="60%"
            style={{
              top: "0",
            }}
          >
            {loginResultObject.user.rpmApplicable === "N" ? (
              <NewPatientRegister
                handleKeyPress={handleKeyPress}
                handleCancel={handleCancel}
                getPatientList={getPatientList}
                videoRef={videoRef}
              />
            ) : (
              <RPMPatientRegistration
                handleCancel={handleCancel}
                handleSave={showModal3}
              />
            )}
          </Modal>
        )}
      </div>

      {/* patient queue design */}
      {isVerticalOpen ? (
        <Draggable>
          <div className="draggable-container fixed top-1/2 right-2 w-14 transform -translate-y-1/2 z-50">
            <div
              className="hidden md:block relative mb-5 cursor-pointer"
              onClick={closeCircle}
            >
              <IoIosCloseCircle className="hidden md:block absolute text-red-400 mb-1 right-0 top-0" />
            </div>
            <img
              src={patientqueue}
              alt="patientqueue"
              className="cursor-pointer"
              title="Patient Queue"
              onClick={showDrawer}
            />
          </div>
        </Draggable>
      ) : (
        <div
          className="vertical"
          style={{ marginTop: "16rem" }}
          onClick={handleClick}
        >
          <p className="vertical-p">
            <div className="vertical-icon-dashboard">
              <MdKeyboardDoubleArrowUp />
            </div>
            Queue
          </p>
        </div>
      )}

      {isDrawerOpen && (
        <div className="grid justify-end mt-5">
          {isDrawerOpen && <PatientQueue onClose={onClose} />}
        </div>
      )}
      {/* patient queue design end */}
    </Layouts>
  );
}

export default Patients;
